import { TranslateFnType } from 'store'
import ToastNotifications from 'store/features/toastNotifications'

export const showProductStreamErrorToast = (
  toastStore: ToastNotifications,
  t: TranslateFnType,
) => {
  toastStore.addNotification({
    id: 'PRODUCT_STREAM_ERROR',
    duration: 8000,
    message: t('Sorry, das hat nicht geklappt'),
    type: 'error',
  })
}
